import React, { useState, useEffect } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch } from "react-redux";
import {
	callAddUserManagement, callEditUserManagement, callGetUserManagementById,
	callGetAllProvince, callGetDistrict, callGetRoles
} from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import { handleInput, handleInvalid, handleGetCookie } from "../../../utils/commonUtil";
import { toast } from "react-toastify";
import "../../../components/i18n/lang";
import { decodeBase64 } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Index = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [user, setUser] = useState({
		userId: null, firstName: '', lastName: '', phone: '', username: '', password: '', userTypeId: 3,
		firebaseToken: '', systemName: '', createBy: '', provinceId: '', districtId: '', village: '',
		modifiedCode: '', modifiedName: '', roleStaff: ''
	});
	const [provinceList, setProvinceList] = useState([]);
	const [districtList, setDistrictList] = useState([]);
	const [roleList, setRoleList] = useState([]);

	let params = useParams();

	useEffect(() => {
		loadInitial();

		if (Object.keys(params).length > 0) {
			let userId = decodeBase64(params?.id)
			if (userId != null) {
				getUserId(userId)
			}
		}

		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setUser((prev) => ({
				...prev,
				createBy: authData?.user?.userId,
				modifiedCode: authData?.user?.userId,
				modifiedName: authData?.user?.firstName + " " + authData?.user?.lastName,
			}));
		}

	}, []);

	const loadInitial = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}

		const rs = await dispatch(callGetRoles());
		if (rs?.payload?.responseCode === "00000") {
			setRoleList(rs?.payload?.data)
		}
	};

	const getUserId = async (userId) => {
		try {
			const rsp = await dispatch(callGetUserManagementById({ userId }));
			if (rsp?.payload?.responseCode === "00000") {
				const item = rsp?.payload?.data
				loadDistrict(item.provinceId);

				setTimeout(() => {
					setUser((prev) => ({
						...prev,
						userId: userId,
						userId: item.userId,
						firstName: item.firstName,
						lastName: item.lastName,
						phone: item.phone,
						systemName: item.systemName,
						provinceId: item.provinceId,
						districtId: item.districtId,
						village: item.village,
						userTypeId: item.userTypeId,
						roleStaff: item.roleStaff
					}));
				}, 100);
			}
		} catch (error) {

		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setUser({
			...user,
			[name]: value,
		});
	};

	const handleSave = async (e) => {
		e.preventDefault()

		if (user.userId != null) {
			let req = {
				userId: user.userId,
				firstName: user.firstName,
				lastName: user.lastName,
				phone: user.phone,
				systemName: "web",
				provinceId: user.provinceId,
				districtId: user.districtId,
				village: user.village,
				userTypeId: user.userTypeId,
				modifiedCode: user.modifiedCode,
				modifiedName: user.modifiedName,
				roleStaff: user.roleStaff
			}
			const res = await dispatch(callEditUserManagement(req));
			console.log(res)
			if (res?.payload?.responseCode === "00000") {
				Swal.fire({
					icon: "success",
					title: t("success.add"),
					confirmButtonColor: "#3085d6",
					confirmButtonText: t('close'),
				}).then(function () {
					notifyListRefresh();
					navigate(-1);
				});
			} else {
				toast.error(res?.payload?.responseCode + " - " + res?.payload?.responseDescription, {
					position: "top-left"
				})
			}
		} else {
			let req = {
				firstName: user.firstName,
				lastName: user.lastName,
				phone: user.phone,
				systemName: "web",
				provinceId: user.provinceId,
				districtId: user.districtId,
				village: user.village,
				userTypeId: user.userTypeId,
				username: user.username,
				password: user.password,
				createBy: user.createBy,
				roleStaff: user.roleStaff
			}
			const res = await dispatch(callAddUserManagement(req));
			if (res?.payload?.responseCode === "00000") {
				Swal.fire({
					icon: "success",
					title: t("success.add"),
					confirmButtonColor: "#3085d6",
					confirmButtonText: t('close'),
				}).then(function () {
					notifyListRefresh();
					navigate(-1);
				});
			} else {
				toast.error(res?.payload?.responseCode + " - " + res?.payload?.responseDescription, {
					position: "top-left"
				})
			}
		}
	}

	const selectRole = (e) => {
		setUser({
			...user,
			userTypeId: e.target.value,
		});
	}

	const selectedProvince = async (e) => {
		e.preventDefault();
		console.log(e.target.value)
		setUser((prev) => ({
			...prev,
			provinceId: e.target.value
		}));

		loadDistrict(e.target.value)
	}

	const selectedRoleStaff = async (e) => {
		e.preventDefault();
		console.log(e.target.value)
		setUser((prev) => ({
			...prev,
			roleStaff: e.target.value
		}));
	}

	const loadDistrict = async (proId) => {
		const rs = await dispatch(callGetDistrict({ provinceId: proId }));
		if (rs?.payload?.responseCode === "00000") {
			setDistrictList(rs?.payload?.data)
		}
	}

	const selectedDistrict = (e) => {
		e.preventDefault();
		setUser((prev) => ({
			...prev,
			districtId: e.target.value
		}));
	}

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{Object.keys(params).length > 0 ? t("user.edit") : t("user.add")}</h4>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-md-3 form-group">
												<label> {t('user.firstName')} <span className="text-danger">*</span> </label>
												<input
													type="text"
													name="firstName"
													className="form-control-uld"
													placeholder={t('user.firstName')}
													onInput={handleInput}
													onChange={handleChange}
													value={user.firstName}
													autoComplete="off"
													required />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('user.lastName')}<span className="text-danger">*</span> </label>
												<input
													type="text"
													name="lastName"
													className="form-control-uld"
													placeholder={t('user.lastName')}
													onInput={handleInput}
													onChange={handleChange}
													value={user.lastName}
													autoComplete="off"
													required />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('user.phone')} <span className="text-danger">*</span> </label>
												<input
													type="number"
													name="phone"
													className="form-control-uld"
													placeholder={t('user.phone')}
													onInput={handleInput}
													onChange={handleChange}
													value={user.phone}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-3 form-group">
												<label> {t('user.role')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													onChange={selectRole}
													value={user.userTypeId}
													required>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														roleList
															.filter((item) => item.id == 3 || item.id == 5)
															.map((item) => (
																<option key={item.id} value={item.id}>{item.name}</option>
															))
													}
												</select>
											</div>

											<div className="col-md-3 form-group">
												<label> {t('user.province')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													onChange={selectedProvince}
													value={user.provinceId}
													required>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														provinceList.map((item) => (
															<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-3 form-group">
												<label> {t('user.district')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													onChange={selectedDistrict}
													value={user.districtId}
													required>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														districtList.map((item) => (
															<option key={item.districtId} value={item.districtId}>{item.districtName}</option>
														))
													}
												</select>
											</div>
											<div className="col-md-3 form-group">
												<label> {t('user.village')}<span className="text-danger">*</span> </label>
												<input
													type="text"
													name="village"
													className="form-control-uld"
													placeholder={t('user.village')}
													onInput={handleInput}
													onChange={handleChange}
													value={user.village}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-3 form-group">
												<label> {t('user.roleStaff')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													onChange={selectedRoleStaff}
													value={user.roleStaff}
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													<option key={1} value="1">{t("roleStaff.1")}</option>
													<option key={2} value="2">{t("roleStaff.2")}</option>
												</select>
											</div>
											{
												Object.keys(params).length > 0 ? null :
													<div className="col-md-6 form-group">
														<label> {t('user.username')}<span className="text-danger">*</span> </label>
														<input
															type="text"
															name="username"
															className="form-control-uld"
															placeholder={t('user.username')}
															onInput={handleInput}
															onChange={handleChange}
															value={user.username}
															min={4}
															autoComplete="off"
															required={Object.keys(params).length > 0 ? false : true} />
													</div>
											}

											{
												Object.keys(params).length > 0 ? null :
													<div className="col-md-6 form-group">
														<label> {t('user.password')}<span className="text-danger">*</span> </label>
														<input
															type="password"
															name="password"
															className="form-control-uld"
															placeholder={t('user.password')}
															onInput={handleInput}
															onChange={handleChange}
															value={user.password}
															min={6}
															autoComplete="off"
															required={Object.keys(params).length > 0 ? false : true} />
													</div>
											}

											<div className="col-12 d-flex justify-content-center">
												<div className="m-3">
													<button className="theme-btn btn-style-one w-100" type="submit">
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};


export default Index;
